import React from 'react'
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Sidebar from './Sidebar';
import Skeleton from '@mui/material/Skeleton';
function Loading() {
    return (
        <div className="flex w-full h-full">
            <Sidebar />
            <div className="bg-[#F7F8FC] w-[100%] overflow-y-scroll rounded-xl">
                <div className="py-3 px-4 flex justify-between items-center">
                    <div className="flex">
                        <Skeleton variant="text" sx={{ fontSize: '1rem', px: '50px', mr: '7px', py: '5px'}} />
                        <h2 className="font-bold text-lg py-[5px]"> • </h2>
                        <Skeleton variant="text" sx={{ fontSize: '1rem', px: '50px', ml: '7px', py: '5px'}} />
                    </div>
                </div>
                <div className="bg-[#F7F8FC] mx-[3%] py-[1%] mb-[5%] mt-[2%]">
                    <Skeleton variant="rectangular" sx={{ width: '100%', padding: '27%' }}/>
                </div>
            </div>
        </div>
    )
}

export default Loading;